const en = {
  app: {
    title: 'AllPhi F&A',
    platformSubtitle: 'Management platform',
    searchPlaceholder: 'Search hub data...',
    openGlobalSearch: 'Open global search',
    clearSearch: 'Clear and close search',
    searchMinimum: 'Type at least 2 characters to search across the application.',
    searchNoResults: 'No results found for “{{term}}”.',
    searchError: 'Some search results could not be loaded. Please try again.',
    searchPages: {
      assets: 'All Assets',
      contracts: 'All Contracts',
      documents: 'Document Search',
      notifications: 'Notification Center',
      mobility: 'Mobility by employee',
    },
    darkMode: 'Dark mode',
    lightMode: 'Light mode',
    notifications: 'Notifications',
    openNotifications: 'Open notifications',
    openNavigation: 'Open navigation',
    collapseSidebar: 'Collapse sidebar',
    expandSidebar: 'Expand sidebar',
    expandNavigationModule: 'Expand {{module}}',
    collapseNavigationModule: 'Collapse {{module}}',
    accountMenu: 'Account menu',
    signOut: 'Sign out',
    notificationCenter: 'Notification Center',
    notificationSubtitle: 'Track open items from the modules you can access',
    openCount: '{{count}} open',
    unreadNewCount: '{{count}} new',
    openNotificationCenterPage: 'Open full notification center',
    entityAsset: 'Asset',
    entityContract: 'Contract',
    entityExpenseClaim: 'Expense claim',
    newBadge: 'New',
    dueLabel: 'Due: {{date}}',
    reminderLabel: 'Reminder: {{date}}',
    openButton: 'Open',
    inOrder: 'In orde',
    allClear: 'All clear',
    noActiveNotifications: 'No active notifications.',
    markedInOrderSuccess: 'Marked as in orde.',
    language: 'Language',
    dutch: 'Dutch',
    english: 'English',
  },
  auth: {
    title: 'AllPhi F&A Platform',
    subtitle: 'Sign in with your Microsoft work account to continue.',
    signIn: 'Sign in',
    accessDeniedTitle: 'Access denied',
    accessDeniedSubtitle: 'Your account does not have access to this application. Request access through the AllPhi Admin group.',
  },
  home: {
    title: 'AllPhi F&A Platform',
    welcome: 'Welcome, {{name}}',
    instruction: 'Use the navigation on the left to open the sections you have access to.',
    noModuleAccess: 'Your account currently has no access to a functional module. You can review the available permissions under Administration.',
  },
  modules: {
    home: 'Home',
    assets: 'Assets',
    notifications: 'Notifications',
    contracts: 'Contracts',
    allAssets: 'All Assets',
    spareAssets: 'Spare Assets',
    endOfLease: 'End of Lease',
    notificationCenter: 'Notification Center',
    contractsDashboard: 'Contract Dashboard',
    contractsAll: 'All Contracts',
    contractsEndingSoon: 'Ending Soon',
    contractsNoticeLead: 'Notice Lead',
    contractDocumentsSearch: 'Document Search',
    supplierContracts: 'Supplier Contracts',
    changeHistory: 'Change history',
    administration: 'Administration',
    mobility: 'Mobility budget',
    mobilityAccounts: 'Employee overview',
    mobilityClaims: 'Expense claims',
    mobilityPayroll: 'Payroll',
  },
  audit: {
    title: 'Change history',
    moduleTitle: '{{module}} change history',
    objectTitle: 'History of {{name}}',
    subtitle: 'Review creations, changes, document actions and deletions. Deleted objects remain visible here.',
    history: 'History',
    openHistory: 'View history',
    search: 'Search object or user',
    action: 'Action',
    allActions: 'All actions',
    date: 'Date and time',
    object: 'Object',
    changedBy: 'Performed by',
    changes: 'Old and new value',
    before: 'Before',
    after: 'After',
    fields: {
      AssetTag: 'Service tag number',
      Category: 'Category',
      Manufacturer: 'Manufacturer',
      Model: 'Model',
      SerialNumber: 'Former serial number',
      Specifications: 'Specifications',
      PurchaseType: 'Purchase type',
      PurchaseDate: 'Purchase date',
      LeasingPrice: 'Lease price',
      LeasingStartDate: 'Lease start date',
      LeasingEndDate: 'Lease end date',
      ContractNumber: 'Contract number',
      PaymentMethod: 'Payment method',
      LeasingCompany: 'Leasing company',
      AssignedEmployeeId: 'Assigned employee',
      OfficeLocationId: 'Office location',
      KeyboardLayout: 'Keyboard layout',
      HasDongle: 'Dongle included',
      BillingTiming: 'Billing timing',
      Status: 'Status',
      Notes: 'Notes',
      CostLines: 'Cost lines',
      EndDate: 'End date',
    },
    empty: 'No changes have been recorded yet.',
    system: 'System',
    actions: {
      Created: 'Created',
      Updated: 'Updated',
      Deleted: 'Deleted',
      DocumentUploaded: 'Document uploaded',
      DocumentRenamed: 'Document renamed',
      DocumentDeleted: 'Document deleted',
      AccessChanged: 'Access changed',
    },
  },
  admin: {
    lastAdministratorProtected: 'The last administrator cannot remove their own administrator role.',
    title: 'Users and module access',
    subtitle: 'Manage application administrators and select which modules each user can access.',
    entraExplanation: 'The user list is loaded read-only from the configured Entra group. These switches do not change group memberships; permissions are stored in this application.',
    entraExplanationCompact: 'Users come from the Entra group; permissions are saved automatically in this application.',
    accessDenied: 'You do not have access to this administration page.',
    search: 'Search user',
    user: 'User',
    admin: 'Administrator',
    actions: 'Action',
    defaultAccess: 'Default access — not explicitly saved yet',
    defaultAccessShort: 'Default',
    contractsShort: 'Contracts',
    mobilityShort: 'Mobility',
    notificationsShort: 'Notifications',
    employeeSyncCompleted: '{{count}} Entra employees synchronized: {{created}} new, {{reactivated}} reactivated and {{deactivated}} deactivated.',
    syncEmployees: 'Synchronize employees',
    saving: 'Saving…',
    savedShort: 'Saved',
    saveFailed: 'Not saved',
    saved: 'Access for {{name}} saved.',
    previewNonAdmin: 'View as non-admin',
    previewActive: 'Non-admin preview is active',
    previewExplanation: 'This is a visual preview only. Your real permissions and saved settings remain unchanged.',
    endPreview: 'End preview',
    readOnlyExplanation: 'You are viewing this page in read-only mode. Only administrators can change administrator permissions and module access.',
  },
  notifications: {
    title: 'Notification Center',
    subtitle: 'Manage lifecycle status, notes, and full history per notification.',
    filterStatus: 'Status filter',
    allStatuses: 'All statuses',
    filterUnread: 'Unread filter',
    filterEntityType: 'Notification source',
    allEntityTypes: 'All accessible modules',
    contracts: 'Contracts',
    assets: 'Assets',
    expenseClaims: 'Expense claims',
    filterAssetType: 'Asset type',
    allAssetTypes: 'All asset types',
    laptop: 'Laptop',
    dockingStation: 'Docking Station',
    allItems: 'All items',
    onlyUnread: 'Only unread',
    noteLabel: 'Note or comment',
    markSeen: 'Mark seen',
    setInProgress: 'Set In Progress',
    setClosed: 'Set Closed',
    setExtended: 'Set Extended',
    addComment: 'Add comment',
    history: 'History',
    historyTitle: 'Notification history',
    historyCycleHelp: 'Cycle means how many times the same notification became active again after being closed.',
    actedBy: 'By: {{name}}',
    noHistory: 'No history available.',
    historyCycle: 'Cycle {{cycle}}',
    seen: 'Seen',
    unseen: 'Unread',
    statusUpdated: 'Notification status updated.',
    commentAdded: 'Comment added to history.',
    commentRequired: 'Please enter a comment in the note field first.',
    noteModalHint: 'A note or comment is requested in a popup when you trigger an action.',
    noteModalTitleStatus: 'Update status',
    noteModalTitleComment: 'Add comment',
    noteModalPlaceholderStatus: 'Optionally add a note for this status change...',
    noteModalPlaceholderComment: 'Type your comment for this notification...',
    columns: {
      status: 'Status',
      title: 'Title',
      message: 'Message',
      dueDate: 'Due date',
      seen: 'Seen',
      actions: 'Actions',
    },
    statuses: {
      New: 'New',
      InProgress: 'In Progress',
      Closed: 'Closed',
      Extended: 'Extended',
    },
    historyActions: {
      Created: 'Created',
      StatusChanged: 'Status changed',
      Reopened: 'Reopened',
      NoteAdded: 'Note added',
      MarkedSeen: 'Marked seen',
      AutoResolved: 'Auto resolved',
    },
    historyNotes: {
      reopenedActive: 'Notification reopened because the condition is still active.',
      reopenedNewCycle: 'Notification reopened in a new cycle.',
      markedSeen: 'Notification marked as seen.',
      created: 'Notification created.',
      autoResolved: 'Automatically resolved because the condition no longer applies.',
      closedByUser: 'Closed by user.',
    },
    generated: {
      contractNoticeTitle: 'Contract {{name}} in notice window',
      contractNoticeMessage: 'Notice period starts on {{date}} for contract {{name}}.',
      contractPendingSignatureTitle: 'Contract {{name}} awaiting signature',
      contractPendingSignatureMessage: 'Contract {{name}} is still waiting for signature. Planned start date: {{date}}.',
      rentalContractTitle: 'Notice period for rental contract {{name}} is approaching',
      rentalContractMessage: 'The notice period for rental contract {{name}} starts on {{date}}.',
      assetLeaseTitle: 'Asset {{name}} lease nearing end',
      assetLeaseMessage: 'Lease ends on {{date}} for asset {{name}}.',
      expenseClaimTitle: 'New expense claim awaiting review',
    },
  },
  common: {
    invalidDateFormat: 'Use a valid date in dd/mm/yyyy format.',
    datePlaceholder: 'dd/mm/yyyy',
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    create: 'Create',
    saveChanges: 'Save changes',
    delete: 'Delete',
    edit: 'Edit',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    noData: '-',
  },
  comingSoon: {
    notFound: 'Not found',
    message: 'This section is planned for an upcoming delivery phase and is not yet available.',
  },
  assets: {
    pageTitle: 'All Assets',
    newAsset: 'New asset(s)',
    exportCsv: 'Export to Excel',
    laptops: 'Laptops',
    dockingStations: 'Docking Stations',
    status: 'Status',
    purchaseType: 'Purchase type',
    columns: {
      assetTag: 'Service tag number',
      category: 'Category',
      manufacturer: 'Manufacturer',
      model: 'Model',
      purchaseType: 'Purchase type',
      keyboard: 'Keyboard',
      dongle: 'Dongle',
      billingTiming: 'Billing timing',
      contractNumber: 'Contract number',
      leaseEndDate: 'Lease end date',
      assignedTo: 'Assigned to',
      formerAssignedTo: 'Former user',
      office: 'Office',
      createdAt: 'Created at',
      modifiedAt: 'Modified at',
      actions: '',
    },
    labels: {
      spare: 'Spare',
      reservedLegacy: 'Reserved (legacy)',
      purchased: 'Purchased',
      leasing: 'Leasing',
    },
    statuses: {
      assigned: 'Assigned',
      spareLaptop: 'Spare',
      reserved: 'Reserved (legacy)',
      repair: 'Repair',
      endOfLease: 'End of lease',
      returned: 'Returned',
      retired: 'Retired',
      broken: 'Broken',
    },
    billingTiming: {
      advance: 'In advance',
      arrears: 'In arrears',
    },
    filters: {
      category: 'Asset type',
      keyboardLayout: 'Keyboard layout',
      statusCount: '{{count}} statuses',
    },
    createDialog: {
      title: 'New asset(s)',
      subtitle: 'Add one or more laptops and docking stations with their complete details.',
      assetCount_one: '{{count}} asset',
      assetCount_other: '{{count}} assets',
      untitledAsset: 'New asset',
      duplicate: 'Duplicate details',
      remove: 'Remove asset',
      addAnother: 'Add another asset',
      create_one: 'Create asset',
      create_other: 'Create {{count}} assets',
    },
    snack: {
      assetDeleted: 'Asset deleted',
      provideOneAssetTag: 'Please provide at least one asset tag.',
      createdAssets: 'Created {{count}} assets.',
      bulkUpdated: 'Updated {{count}} assets.',
    },
    bulkEdit: {
      action: 'Bulk edit ({{count}})',
      title: 'Bulk edit assets',
      help: 'Choose which value to change for {{count}} selected assets. Every change is recorded per asset.',
      leaseEndDate: 'Lease end date',
      status: 'Status',
      newEndDate: 'New lease end date',
      newStatus: 'New status',
      confirm: 'Update assets',
    },
    confirmDeleteTitle: 'Delete asset',
    confirmDeleteMessage: 'Are you sure you want to delete this asset? This action cannot be undone.',
    actions: {
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
    },
  },
  assetForm: {
    editTitle: 'Edit asset',
    createTitle: 'New asset',
    fields: {
      assetTag: 'Service tag number',
      category: 'Category',
      manufacturer: 'Manufacturer',
      model: 'Model',
      keyboardLayout: 'Keyboard layout',
      hasDongle: 'Dongle included',
      billingTiming: 'Billing timing',
      specifications: 'Specifications',
      purchaseType: 'Purchase type',
      status: 'Status',
      assignedTo: 'Assigned to',
      officeLocation: 'Office location',
      purchaseDate: 'Purchase date',
      leasingCompany: 'Leasing company',
      contractNumber: 'Contract number',
      leasingPrice: 'Leasing price',
      leaseStart: 'Lease start',
      leaseEnd: 'Lease end',
      notes: 'Notes',
    },
    statuses: {
      spare: 'Spare',
    },
    actions: {
      create: 'Create',
      saveChanges: 'Save changes',
    },
    validation: {
      required: 'This field is required.',
    },
    snack: {
      updated: 'Asset updated',
      created: 'Asset created',
    },
  },
  assetDetails: {
    title: 'Asset details',
    noAsset: 'No asset selected.',
    assignmentHistoryTitle: 'Assignment history',
    loadingHistory: 'Loading history...',
    noAssignmentHistory: 'No assignment history available yet.',
    historyPeriodFrom: 'From {{date}}',
    historyPeriodTo: 'To {{date}}',
    historyCurrent: 'Current assignment',
    historyPeriodUnknown: 'Period unknown',
    labels: {
      assetTag: 'Service tag number',
      category: 'Category',
      manufacturer: 'Manufacturer',
      model: 'Model',
      keyboardLayout: 'Keyboard layout',
      hasDongle: 'Dongle included',
      billingTiming: 'Billing timing',
      purchaseType: 'Purchase type',
      purchaseDate: 'Purchase date',
      leasingEnd: 'Leasing end',
      leasingPrice: 'Leasing price',
      contractNumber: 'Contract number',
      status: 'Status',
      assignedTo: 'Assigned to',
      formerAssignedTo: 'Former user',
      office: 'Office',
      note: 'note',
    },
    metadataTitle: 'CSV metadata',
    noMetadata: 'No CSV metadata found.',
  },
  spareAssets: {
    title: 'Spare Assets',
    subtitle: 'Assets currently in spare status. The office location can be completed in the asset record.',
    columns: {
      assetTag: 'Service tag number',
      manufacturer: 'Manufacturer',
      model: 'Model',
      keyboard: 'Keyboard',
      office: 'Office',
      leaseEnd: 'Lease end',
    },
  },
  endOfLease: {
    title: 'End of Lease',
    subtitle: 'Assets with lease end date between today and the next {{months}} months.',
    columns: {
      assetTag: 'Service tag number',
      manufacturer: 'Manufacturer',
      model: 'Model',
      contract: 'Contract',
      leaseEndDate: 'Lease end date',
      daysLeft: 'Days left',
      assignedTo: 'Assigned to',
      office: 'Office',
    },
    days: '{{count}} days',
  },
  contracts: {
    incompleteFlag: 'Contract is marked as incomplete',
    pendingSignature: 'Pending Signature',
    title: 'Supplier Contracts',
    subtitle: 'Active contracts, expirations, and supplier commitments.',
    views: {
      all: {
        title: 'All Contracts',
        subtitle: 'All supplier contracts, regardless of lifecycle window.',
      },
      endingSoon: {
        title: 'Contracts Ending Soon',
        subtitle: 'Contracts ending between {{min}} and {{max}} months from now.',
      },
      noticeLead: {
        title: 'Notice Lead Window',
        subtitle: 'Contracts whose notice start date falls between {{min}} and {{max}} months from now.',
      },
    },
    newContract: 'New contract',
    filters: {
      contractType: 'Contract type',
      allContractTypes: 'All contract types',
      noticeLeadMinMonths: 'From (months)',
      noticeLeadMaxMonths: 'To (months)',
      endingSoonMinMonths: 'From (months)',
      endingSoonMaxMonths: 'To (months)',
      status: 'Status',
    },
    cards: {
      active: 'Active',
      activeSplit: 'Recurring: {{standard}} · One-time: {{oneTime}} · Rental: {{rental}}',
      expiring90: 'Expiring In 90 Days',
      totalValueAnnualized: 'Total Value (All Contracts, Annualized)',
      totalRecurringAnnualized: 'Recurring Value (Annualized)',
      totalOneTimeCommitment: 'One-time commitments: EUR {{value}}',
      expired: 'Expired',
    },
    columns: {
      title: 'Title',
      supplier: 'Supplier',
      contractValue: 'Contract Value (Annualized)',
      endDate: 'End Date',
      noticePeriod: 'Notice period',
      daysLeft: 'Days Left',
      status: 'Status',
      shortNote: 'Short note',
    },
    expiredCell: 'Expired',
    confirmDeleteTitle: 'Delete contract "{{title}}" ({{supplier}})?',
    confirmDeleteMessage: 'This contract and all uploaded documents will be deleted.',
    snack: {
      deleted: 'Contract deleted',
    },
    actions: {
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
    },
    statuses: {
      draft: 'Draft',
      active: 'Active',
      pendingSignature: 'Pending Signature',
      expired: 'Expired',
      terminated: 'Terminated',
    },
  },
  contractDashboard: {
    title: 'Contract Dashboard',
    subtitle: 'Insights into contract status, deadlines, completeness, and financial commitments.',
    period: 'View',
    month: 'Month',
    year: 'Year',
    currency: 'Currency',
    allCurrencies: 'All currencies',
    showDetails: 'View underlying contracts',
    noContracts: 'No contracts for this statistic in the selected period.',
    contractCount: '{{count}} contract(s)',
    periodExplanation: 'Figures cover {{start}} through {{end}}. Recurring value is annualized; one-time commitments are counted on the contract start date.',
    currencyExplanation: 'Amounts in different currencies are shown separately and are never added together.',
    metrics: {
      totalContracts: { title: 'Contracts in period' },
      activeContracts: { title: 'Active contracts' },
      incompleteContracts: { title: 'Incomplete contracts' },
      startingInPeriod: { title: 'Starting in this period' },
      endingInPeriod: { title: 'Ending in this period' },
      noticeDeadlinesInPeriod: { title: 'Notice deadlines' },
      indefiniteContracts: { title: 'Indefinite contracts' },
      missingDocuments: { title: 'Without documents' },
      recurringAnnualValue: { title: 'Recurring value (annualized)' },
      oneTimeCommitment: { title: 'One-time commitments' },
    },
  },
  contractDetails: {
    title: 'Contract details',
    loading: 'Loading contract details...',
    supplier: 'Supplier',
    contractName: 'Contract name',
    contractType: 'Contract type',
    status: 'Status',
    incomplete: 'Incomplete — attention required',
    startDate: 'Start date',
    endDate: 'End date',
    costs: 'Annual costs',
    costLines: 'Cost lines',
    documents: 'Uploaded documents',
    noticePeriod: 'Notice period',
    noticeDeadline: 'Notice deadline',
    renewalInformation: 'Renewal information',
    fixedTermRenewal: 'Fixed-term contract ending on {{date}}.',
    indefiniteRenewal: 'Indefinite contract; no renewal or end date is scheduled.',
    indefinite: 'Indefinite',
    notSet: 'Not set',
    notApplicable: 'Not applicable',
    notificationInfo: {
      label: 'Notification timing information',
      title: 'When will the notification be generated?',
      oneTime: 'No notifications are generated for a one-time agreement.',
      missingEndDate: 'No date-based notification is generated until an end date is set.',
      missingNoticePeriod: 'No date-based notification is generated until a notice period is set.',
      standard: 'The notification is generated on {{date}}, one month before the notice deadline on {{noticeDate}}.',
      rental: 'The notification is generated on {{date}}, six months before the notice period starts on {{noticeDate}}.',
      pendingSignature: 'A notification is active now because the contract is awaiting signature. After activation: {{schedule}}',
      inactive: '{{schedule}} The date-based notification is only created while the contract is active.',
      notAvailable: 'The notification date could not be calculated.',
    },
  },
  contractDocumentSearch: {
    title: 'Contract Document Search',
    subtitle: 'Search across all uploaded contract documents by file name, and PDFs also by their content.',
    searchLabel: 'Search term',
    searchPlaceholder: 'Try supplier name, invoice text, clause or keyword...',
    supplierLabel: 'Supplier filter (optional)',
    searchButton: 'Search',
    globalHint: 'Tip: if the search box in the top bar has text, it is also used here.',
    minSearchHint: 'Enter at least 2 characters to search documents.',
    indexCoverage: 'Indexed content: {{extracted}} / {{total}} documents',
    noSnippet: 'No text snippet available for this result.',
    open: 'Open',
    columns: {
      fileName: 'File name',
      contract: 'Contract',
      supplier: 'Supplier',
      snippet: 'Matching snippet',
      matches: 'Match source',
    },
    matchTags: {
      fileName: 'File name',
      content: 'Content',
    },
  },
  contractForm: {
    editTitle: 'Edit contract',
    createTitle: 'New contract',
    loadingDetails: 'Loading contract details...',
    fields: {
      supplier: 'Supplier',
      title: 'Title',
      completeness: 'Contract completeness',
      contractDate: 'Contract date',
      startDate: 'Start date',
      endDate: 'End date',
      contractType: 'Contract type',
      currency: 'Currency',
      noticePeriod: 'Notice period',
      noticePeriodDisabledForOneTime: 'Notice period is not used for one-time contracts.',
      unit: 'Unit',
      status: 'Status',
      shortNote: 'Short note',
      notes: 'Notes',
      setStatusManually: 'Set status manually',
      costLines: 'Cost lines',
      addLine: 'Add line',
      label: 'Label',
      costLineLabelPlaceholder: 'Fixed cost',
      quantity: 'Quantity',
      unitPrice: 'Unit price',
      periodType: 'Period',
      removeCostLine: 'Remove cost line',
    },
    completeness: {
      complete: 'Complete',
      incomplete: 'Incomplete',
      help: 'Mark as incomplete when information or documentation is missing.',
    },
    periods: {
      monthly: 'Monthly',
      quarterly: 'Quarterly',
      yearly: 'Yearly',
      oneTime: 'One-time',
      fullContract: 'Entire contract duration',
    },
    noticeUnits: {
      days: 'Days',
      weeks: 'Weeks',
      months: 'Months',
    },
    contractTypes: {
      standard: 'Recurring contract',
      oneTime: 'One-time agreement',
      rental: 'Rental contract',
    },
    statusHelp: {
      manualEnabled: 'Manual override is enabled. Toggle off to use automatic status from dates.',
      automatic: 'Automatic status: {{status}}',
    },
    document: {
      createDocumentOptional: 'You can optionally add one or more contract documents.',
      dropOrBrowse: 'Drag and drop files here or click to browse',
      supportedFileTypes: 'PDF, Word, Excel, PowerPoint, OpenDocument, RTF, TXT, CSV, email (MSG, EML) and images (PNG, JPG, TIFF)',
      selected: 'Selected: {{name}}',
      removeSelectedDocument: 'Remove',
      contractDocuments: 'Contract documents',
      noDocument: 'No document uploaded yet.',
      viewDocument: 'Open',
      deleteDocument: 'Delete document',
      renamePdf: 'Rename',
      renameTitle: 'Rename document',
      fileName: 'Filename',
      renamed: 'Document renamed.',
      deleted: 'Document removed.',
      uploadNewDocument: 'Upload new document',
      unsupportedFileType: '{{name}} has a file type that is not supported.',
    },
    validation: {
      required: 'This field is required.',
      quantityPositive: 'Quantity must be greater than 0.',
      unitPriceNonNegative: 'The price cannot be negative.',
      priceRequired: 'Enter a valid price.',
      endDateBeforeStart: 'The end date cannot be before the start date.',
      notesRequiredWhenIncomplete: 'Notes are required when the contract is marked as not complete.',
    },
    actions: {
      create: 'Create contract',
      saveChanges: 'Save changes',
    },
    snack: {
      updated: 'Contract updated',
      created: 'Contract created',
    },
  },
  mobility: {
    fields: {
      employee: 'Employee',
      year: 'Year',
      annualBudget: 'Annual budget',
      availableBalance: 'Available balance',
      status: 'Status',
      actions: 'Actions',
      date: 'Date',
      entryType: 'Entry type',
      pillar: 'Pillar',
      amount: 'Amount',
      description: 'Description',
      expenseType: 'Expense type',
      attachments: 'Attachments',
    },
    accounts: {
      title: 'Mobility budget accounts',
      subtitle: 'Manage employees\u2019 annual mobility budgets and their ledger.',
      create: 'New account',
      created: 'Budget account created.',
      closed: 'Budget account closed.',
      settled: 'Pillar 3 settled. Net paid out: {{net}}.',
      ledger: 'Ledger',
      ledgerTitle: 'Ledger of {{name}} ({{year}})',
      stateOpen: 'Open',
      stateClosed: 'Closed',
    },
    ledger: {
      subtitle: 'Releases and expenses shown as clear chronological movements. Technical recalculations are not displayed as transactions.',
      regularReleased: 'Released normally',
      expenses: 'Expenses',
      noTransactions: 'No transactions for this book year yet',
      rowsPerPage: 'Rows per page:',
      types: {
        BudgetGrant: 'Annual budget',
        CarCost: 'Vehicle cost',
        ExpenseReimbursement: 'Expense',
        CashPayout: 'Pillar 3 payout',
        Adjustment: 'Adjustment',
        MonthlyRelease: 'Monthly release',
        YearlyRelease: 'Yearly release',
      },
      descriptions: {
        MonthlyRelease: 'Mobility budget released at the end of the month',
        YearlyRelease: 'Full remaining annual budget released in one go',
        ExpenseReimbursement: 'Expense claim reimbursement #{{id}}',
        ExpenseReimbursementDetailed: '{{type}}',
        ExpenseRefund: 'Refund of cancelled expense claim #{{id}}',
        ExpenseRefundDetailed: 'Reversal: {{type}}',
      },
      reversed: 'Reversed',
    },
    employeeData: {
      open: 'Employee data',
      title: 'Employee mobility data',
      subtitle: 'Manage each employee’s employment start date and relevant experience used by the mobility calculation.',
      email: 'Email address',
      startDate: 'Employment start date',
      relevantYears: 'Relevant experience before AllPhi (years)',
      link: 'Entra linked',
      editTitle: 'Mobility data – {{name}}',
      saved: 'Mobility data saved.',
      employeeType: 'Employee type',
      employeeTypeConsultant: 'Consultant',
      employeeTypeOverhead: 'Overhead',
    },
    employeeOverview: {
      title: 'Mobility by employee',
      subtitle: 'Categories, current vehicle, mobility budget and expense claims in one overview.',
      currentCategory: 'Eligible category',
      assignedCategory: 'Assigned category',
      absoluteCategory: 'Absolute category',
      vehicleCategory: 'Mobility budget category',
      expenses: 'Expense claims',
      expenseSummary: '{{count}} total · {{pending}} open',
      openDetails: 'Open complete employee overview',
      history: 'History',
      openHistory: 'View history',
      editProfile: 'Edit data',
      activeSince: 'Active since {{date}}',
      notSet: 'Not set yet',
      categorySwitchChangedOn: 'Effective on {{date}}',
      categorySwitchTakesEffectOn: 'Takes effect on {{date}}',
      calculatedDetail: 'Calculated from {{years}} relevant years and {{points}} points',
      absoluteDetail: '{{years}} relevant years · {{points}} points',
      noVehicle: 'No active vehicle assigned',
      profile: 'Employee data',
      budget: 'Mobility budget {{year}}',
      expenseTitle: 'Expense claims {{year}}',
      changeEntitledCategoryTitle: 'Change assigned category – {{name}}',
      changeEntitledCategoryInfo: 'Pick the date the new category should take effect. It does not affect the vehicle or the lease term.',
      changeEntitledCategoryEffectiveDate: 'Effective date',
      changeEntitledCategoryResolvedDate: 'The change will take effect on {{date}}.',
      changeEntitledCategoryVehicleUnaffected: 'This change does not affect the vehicle or the lease term.',
      changeEntitledCategoryBookYear: 'Book year {{year}}',
      changeEntitledCategoryDaysSplit: '{{before}} days old / {{after}} days new',
      changeEntitledCategoryPreviousBudget: 'Previous mobility budget',
      changeEntitledCategoryNewBudget: 'New mobility budget',
      changeEntitledCategoryBudgetDelta: 'Budget difference',
      changeEntitledCategoryConfirm: 'Confirm change',
      categorySaved: 'Assigned category changed.',
      bookYearsTitle: 'Mobility budget book years',
      bookYearsSubtitle: 'Daily pro-rata projection across the full 48-month lease. Free budget is the gross TCO entitlement minus the selected vehicle cost.',
      bookYear: 'Book year',
      activeDays: 'Active days',
      grossTcoEntitlement: 'Gross TCO entitlement',
      vehicleCost: 'Vehicle cost (pillar 1)',
      projectedFreeBudget: 'Projected free budget',
      noLease: 'No lease period configured yet',
      employmentStatus: 'Employment status',
      active: 'Active',
      inactive: 'Inactive',
      allStatuses: 'All statuses',
      permanentDelete: 'Delete permanently',
      permanentDeleteTitle: 'Delete inactive profile',
      permanentDeleteWarning: 'This permanently removes {{name}} and the account link. Profiles with mobility or payroll history must remain archived for audit purposes and cannot be permanently deleted.',
      deleted: 'The employee profile was permanently deleted.',
      entraLink: 'Entra link',
      linked: 'Linked',
      notLinked: 'Not linked',
      deleteDuplicate: 'Delete duplicate profile',
      deleteDuplicateTitle: 'Delete unlinked profile',
      deleteDuplicateWarning: 'Only delete {{name}} when this is a duplicate unlinked profile and the linked Entra profile will remain. A profile with mobility or payroll history cannot be deleted.',
      budgetAvailability: 'Mobility budget',
      available: 'Available',
      unavailable: 'Not active',
      budgetEnabled: 'The mobility budget has been enabled.',
      budgetDisabled: 'The mobility budget has been disabled.',
      budgetInactiveInfo: 'The mobility budget is not active for this employee yet. The internal lease and book-year projection remains visible to F&A, but no budget account, releases or employee actions are enabled.',
      releaseModeMonthly: 'Monthly release',
      releaseModeYearly: 'Yearly release',
    },
    leaverSimulation: {
      action: 'Simulate leaver settlement',
      title: 'Leaver mobility-budget settlement simulation',
      explanation: 'This is a read-only projection of what would be owed to or by the employee if they left on the chosen date. It does not book any ledger entries or change the account.',
      departureDate: 'Departure date',
      calculate: 'Calculate',
      annualBudget: 'Annual budget',
      standardReleased: 'Standard released to date',
      releaseBreakdownTitle: 'Release breakdown',
      alreadyReleased: 'Already released (up to today)',
      upcomingRelease: 'Release on {{date}}',
      partialMonth: 'Daily rate: {{dailyRate}} — partial current month added to balance: {{amount}}',
      dailyRate: 'Daily rate',
      daysEmployedCalculation: '{{days}} days × {{dailyRate}} (Daily rate)',
      costsTitle: 'Costs',
      otherMovementsTitle: 'Other movements',
      owedToEmployee: 'Owed to employee: {{amount}}',
      owedByEmployee: 'Owed by employee: {{amount}}',
      nothingOwed: 'Nothing owed either way',
      yearSectionTitle: '{{year}}',
      projectedSuffix: '(projected)',
      projectedBudgetNote: 'No mobility account exists yet for this year — the amount below is an estimate based on the current annual budget and will be recalculated once a real account is created.',
    },
    vehicleLease: {
      title: 'Vehicle category and lease period',
      startDate: 'Lease contract start date',
      endDate: 'Lease contract end date',
      extendAction: 'Extend lease period',
      extendTitle: 'Extend by a number of months',
      extendExplanation: 'The months are added to the current end date {{endDate}}. You can then review the existing calculation before saving.',
      extensionMonths: 'Number of months',
      applyExtension: 'Apply extension',
      tcoMissing: 'No TCO is configured for category {{entitled}} or {{vehicle}} on this start date. Configure it first through TCO categories with an effective date on or before the lease start.',
      lockedAmounts: 'Locked for 48 months: entitlement {{entitled}} per month, vehicle {{vehicle}} per month.',
      categoryRequired: 'Set the employee’s current category first.',
      entitledCategoryHelp: 'Capped by the employee’s current eligibility. Choose a lower category for the vehicle if needed.',
      explanation: 'A new lease defaults to four years. Extending a lease keeps the originally locked TCO amounts.',
      calculate: 'Review calculation',
      previewTitle: 'Impact of this change',
      previewSubtitle: 'This is a simulation. Nothing is saved until you confirm below.',
      periodChange: 'Lease period change',
      entitledSnapshot: 'TCO entitlement snapshot / month',
      vehicleSnapshot: 'Vehicle TCO snapshot / month',
      monthlyDifference: 'Free budget / month',
      bookYearImpact: 'Difference caused by this change',
      noBookYearImpact: 'This change has no impact on the calculated book years.',
      daysChange: '{{count}} days',
      activeDaysComparison: 'Active lease days: {{before}} → {{after}} of {{total}}',
      grossChange: 'TCO entitlement change',
      vehicleCostChange: 'Vehicle cost change',
      freeBudgetChange: 'Free budget change',
      calculationWarning: 'Confirming saves the lease details and recalculates all affected book years and ledger corrections. Carefully check the period, category and TCO amounts.',
      confirmCalculation: 'Save and recalculate budget',
      saveAndCalculate: 'Save and calculate',
      saved: 'Lease period and book years have been updated.',
      historicalStartInfo: 'You may enter the actual historical start date. The assigned category and complete TCO set must be valid on that date. While mobility budget is disabled, an existing lease can also be corrected historically.',
    },
    tco: {
      action: 'TCO categories',
      title: 'TCO by vehicle category',
      subtitle: 'Manage the monthly all-in cost that is locked for 48 months when a lease starts.',
      newVersion: 'New TCO version',
      existingLeaseInfo: 'Existing leases always keep their original amounts.',
      effectiveFrom: 'Effective from',
      monthlyTco: 'Monthly TCO',
      eurPerMonth: 'EUR / month',
      loading: 'Loading…',
      saved: 'TCO for category {{category}} saved.',
      setSaved: 'The complete TCO set has been saved.',
      completeSetWarning: 'A change always applies to all four categories together. Once saved, the set remains immutable in history; corrections require a new effective date.',
      saveCompleteSet: 'Save complete TCO set',
      historyTitle: 'TCO history',
      historySubtitle: 'View previous amounts and their validity period.',
      perMonth: 'per month',
      perYear: 'per year',
      category: 'Category',
      monthlyAmount: 'Monthly TCO',
      annualEquivalent: 'Annual equivalent',
      current: 'present',
      noHistory: 'No TCO history is available yet.',
    },
    claims: {
      title: 'Review expense claims',
      subtitle: 'Open an expense claim to verify its details and supporting documents before deciding.',
      approve: 'Approve',
      overBudgetWarning: 'The available balance is {{available}}. Approval requires an additional {{shortfall}} that is not yet available.',
      noDescription: 'No description',
      reject: 'Reject',
      approved: 'Expense claim approved.',
      rejected: 'Expense claim rejected.',
      rejectTitle: 'Reject expense claim',
      comment: 'Reason for rejection',
      reviewTitle: 'Review expense claim',
      claimReference: 'Expense claim #{{id}}',
      submittedAt: 'Submitted on',
      supportingDocuments: 'Supporting documents',
      noSupportingDocuments: 'No supporting documents were added to this expense claim.',
      noSupportingDocumentsCommute: 'No supporting documents were added. They are not required for commuting.',
      homeAddress: 'Home address',
      workAddress: 'Work address',
      amountToBeCalculated: 'To be calculated',
      distanceKm: 'Distance',
      pricePerKm: 'Price per km',
      calculatedAmount: 'Calculated amount',
      requiredForApproval: 'Required to approve.',
      lastPricePerKmHint: 'Taken from the most recently approved commuting claim.',
      previousDistanceHint: 'Taken from expense claim #{{id}} with the same addresses.',
      invalidDistance: 'Enter a distance greater than 0, with at most 2 decimals.',
      invalidPricePerKm: 'Enter a price greater than 0, with at most 4 decimals.',
      distanceCalculation: 'Calculation',
      distanceBreakdown: '{{km}} km × {{rate}} per km',
      viewDocument: 'View',
      decisionHistory: 'Decision history',
      decisionTitle: 'Decision',
      decisionHelp: 'Verify all details and supporting documents first. A comment is optional for approval and required for rejection.',
      reviewComment: 'Reviewer comment',
      commentRequiredForRejection: 'Required when rejecting the expense claim.',
      statusOverview: 'Status overview',
      filters: {
        Pending: 'To review',
        Approved: 'Approved',
        Rejected: 'Rejected',
        Processed: 'Processed',
        All: 'All',
      },
    },
    decisionType: {
      Approved: 'Approved',
      Rejected: 'Rejected',
      ReturnedForInformation: 'Returned for more information',
    },
    claimStatus: {
      Draft: 'Draft',
      Submitted: 'Submitted',
      UnderReview: 'Under review',
      Approved: 'Approved',
      Rejected: 'Rejected',
      PayrollReady: 'Payroll ready',
      Processed: 'Processed',
      Cancelled: 'Cancelled',
    },
    payroll: {
      title: 'Payroll',
      subtitle: 'Review approved expense claims and include the selected claims in a payroll run.',
      month: 'Month',
      proForma: 'View preview',
      finalize: 'Create payroll run',
      proFormaDone: 'Preview created with {{count}} lines. This preview is not stored.',
      finalizeDone: 'Payroll run completed with {{count}} expense claims.',
      reference: 'Summary',
      kind: 'Type',
      lines: 'Claims',
      total: 'Total gross',
      createdAt: 'Created at',
      approvedClaimsTitle: 'Ready for payroll ({{count}})',
      approvedClaimsSubtitle: 'These approved expense claims are waiting for a final payroll run.',
      noApprovedClaims: 'There are currently no approved expense claims waiting for payroll.',
      processingPeriod: 'Processing period: {{period}}',
      processingPeriodLabel: 'Month to process',
      historyPeriodLabel: 'Execution month',
      periodAlreadyProcessed: '{{period}} has already been processed definitively. Select another month to run a new monthly processing.',
      confirmTitle: 'Create the final payroll run?',
      confirmSubtitle: 'Review the expense claims included for {{period}}.',
      confirmSubtitleNoPeriod: 'Select all approved expense claims that should be included in this payroll run.',
      irreversibleTitle: 'This action cannot be reversed',
      irreversibleText: 'The expense claims below will be processed definitively. The entire monthly run can only be reversed through an explicit correction with a reason.',
      summaryPeriod: 'Period',
      summaryExecutionDate: 'Execution date',
      summaryEmployees: 'Employees',
      summaryClaims: 'Expense claims',
      summaryTotal: 'Total',
      includedClaims: 'Included expense claims',
      includedClaimsSubtitle: 'Deselect claims that should not yet be included in this payroll run. The expense date does not limit the selection.',
      confirmFinalize: 'Confirm payroll run',
      reverseAction: 'Reverse payroll run',
      reverseTitle: 'Reverse finalized payroll run?',
      reverseExplanation: 'All claims in this payroll run return to Approved. The existing run remains visible as Cancelled in history, after which a corrected run can be created.',
      reverseReason: 'Reason for correction',
      reverseConfirm: 'Reverse and reopen',
      reverseDone: 'The payroll run was reversed. The claims are ready for processing again.',
      reversedLabel: 'This payroll run was reversed',
      exportsTitle: 'Generated payroll summaries',
      exportsSubtitle: 'Filter by the month in which the payroll run was executed, then open a summary for details or CSV export.',
      exportDetails: 'Payroll summary details',
      generatedAt: 'Generated at',
      grossAmount: 'Gross amount',
      exportCsv: 'Export as CSV',
      csvEmployee: 'Employee',
      csvPillarTwoCategory: 'Pillar 2 category',
      csvDescription: 'Description',
      csvAmount: 'Gross amount',
      csvCurrency: 'Currency',
      pillarTwoCategory: 'Pillar 2 category',
      tabsLabel: 'Payroll sections',
      tabs: {
        payroll: 'Expense claims and payroll runs',
        pillarThree: 'Pillar 3 year-end settlement',
      },
      kinds: {
        ProForma: 'Preview',
        Final: 'Final',
      },
      statuses: {
        Draft: 'Draft',
        Generated: 'Generated',
        Finalized: 'Finalized',
        Cancelled: 'Cancelled',
      },
    },
    pillarThree: {
      title: 'Pillar 3 year-end settlement',
      subtitle: 'Review and process unused mobility budget for a closed book year in one operation.',
      explanation: 'The remaining budget is paid out gross through Pillar 3. The special employee contribution of 38.07% is withheld and the net amount is paid to the employee.',
      gross: 'Gross remainder',
      contribution: '38.07% contribution',
      net: 'Net payout',
      settledStatus: 'Processed',
      readyStatus: 'Ready to process',
      projectedStatus: 'Projection',
      onlyClosedYears: 'Pillar 3 can only be executed after the selected book year has fully ended.',
      settleAll: 'Process all ({{count}})',
      confirmTitle: 'Execute Pillar 3 for {{year}}?',
      confirmText: 'The remaining budget for {{count}} employees will be settled definitively and their budget accounts will be closed. This action is recorded in the audit history.',
      confirm: 'Process definitively',
      completed: '{{count}} payouts processed. Total net: {{net}}.',
      exportCsv: 'Export CSV',
    },
  },
};

export default en;
